module.exports = __webpack_public_path__ + "img/paper-plane.50be8897.svg";